require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/fn/object/set-prototype-of.js
// module id = 468
// module chunks = 1